import React from "react";
import { useVeltClient } from "../context";
/**
 * @beta This hook is in beta
 */
export function useLiveSelectionUtils() {
    var _a = React.useState(), selectionElement = _a[0], setSelectionElement = _a[1];
    var client = useVeltClient().client;
    React.useEffect(function () {
        if (!client || selectionElement)
            return;
        var loadedSelectionElement = client.getSelectionElement();
        setSelectionElement(loadedSelectionElement);
    }, [client, setSelectionElement, selectionElement]);
    return selectionElement;
}
